var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStipop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24 Extensions/Stipop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24-Extensions/Stipop",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1 C18.2989899,1 23,5.70101013 23,11.5 C23,17.2039245 18.451858,21.8455734 12.7842951,21.9962258 L12.5,22 L6,23 L6.47908443,20.1033393 C3.77065445,18.2043706 2,15.0589646 2,11.5 C2,5.70101013 6.70101013,1 12.5,1 Z M12.5,2.5 C7.52943725,2.5 3.5,6.52943725 3.5,11.5 C3.5,14.3705191 4.85206397,17.0112175 7.09635804,18.6980916 L7.34021132,18.8751453 L8.11298335,19.416961 L7.817,21.202 L12.3852902,20.5 L12.5,20.5 C17.4705627,20.5 21.5,16.4705627 21.5,11.5 C21.5,6.52943725 17.4705627,2.5 12.5,2.5 Z M13.5,12.3 C13.1666667,13.9666667 12.3333333,14.8 11,14.8 C9.66666667,14.8 8.83333333,13.9666667 8.5,12.3 L13.5,12.3 Z M15.0030662,6.67300699 C15.1656001,6.92305919 15.1180007,7.24908483 14.9043132,7.44344192 L14.826993,7.50306617 L13.632,8.279 L14.8086975,8.98550424 C15.0644308,9.13894425 15.1646368,9.45281874 15.0578342,9.72120324 L15.0144958,9.80869745 C14.8610557,10.0644308 14.5471813,10.1646368 14.2787968,10.0578342 L14.1913025,10.0144958 L12.1913025,8.81449576 C11.8402552,8.60386734 11.8048611,8.12100565 12.0939654,7.85785853 L12.173007,7.79693383 L14.173007,6.49693383 C14.4508428,6.31634058 14.8224729,6.39517122 15.0030662,6.67300699 Z M8.1,6.7 C8.92842712,6.7 9.6,7.37157288 9.6,8.2 C9.6,9.02842712 8.92842712,9.7 8.1,9.7 C7.27157288,9.7 6.6,9.02842712 6.6,8.2 C6.6,7.37157288 7.27157288,6.7 8.1,6.7 Z",
    id: "Oval"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStipop);
export default __webpack_public_path__ + "static/media/stipop.4356174a3803ef6163ab57b5761480e2.svg";
export { ForwardRef as ReactComponent };